import { useState } from 'react';
import { Affix, ActionIcon, Tooltip, Transition, Loader } from '@mantine/core';
import { IconBug } from '@tabler/icons-react';
import { notifications } from '@mantine/notifications';
import { IssueReporterModal } from './IssueReporterModal';
import { useScreenshot } from './useScreenshot';

export function IssueReporterFab() {
  const [opened, setOpened] = useState(false);
  const [screenshotBlob, setScreenshotBlob] = useState<Blob | null>(null);
  const { capture, capturing } = useScreenshot();

  const handleClick = async () => {
    // Capture screenshot BEFORE opening modal so the modal isn't in the shot
    const blob = await capture();
    if (!blob) {
      notifications.show({
        title: 'Screenshot capture skipped',
        message: 'Could not capture the screen. You can still describe the issue.',
        color: 'yellow',
        autoClose: 3000,
      });
    }
    setScreenshotBlob(blob);
    setOpened(true);
  };

  const handleClose = () => {
    setOpened(false);
    setScreenshotBlob(null);
  };

  return (
    <>
      <Affix position={{ bottom: 20, right: 20 }} data-issue-reporter="true">
        <Transition transition="slide-up" mounted>
          {(styles) => (
            <Tooltip label={capturing ? 'Capturing...' : 'Report an issue'} position="left">
              <ActionIcon
                style={styles}
                size="xl"
                radius="xl"
                variant="filled"
                color="red"
                onClick={handleClick}
                loading={capturing}
              >
                {capturing ? <Loader size={20} color="white" /> : <IconBug size={24} />}
              </ActionIcon>
            </Tooltip>
          )}
        </Transition>
      </Affix>

      <IssueReporterModal
        opened={opened}
        onClose={handleClose}
        initialScreenshot={screenshotBlob}
      />
    </>
  );
}
